import React, { FC, useState } from "react";

import Translated from "../infrastructure/translation/Translated";
import { LanguageLinks } from "../infrastructure/translation/translate";
import styles from "./Header.module.less";
import Logo from "./Logo";

const Header: FC = (): React.ReactElement => {
  const [showLanguageMenu, setShowLanguangeMenu] = useState(false);

  return (
    <header className={styles.header}>
      <Logo />
      <button
        onClick={() => setShowLanguangeMenu((prevState) => !prevState)}
        className={styles.headerItem}
      >
        <Translated textKey="login.header_langauge" />
      </button>
      {showLanguageMenu && (
        <div className={styles.headerLanguageMenu}>
          <ul className={styles.headerLanguageList}>
            <LanguageLinks style={styles.headerLanguageLink} />
          </ul>
        </div>
      )}
    </header>
  );
};

export default Header;
